__turbopack_context__.v({
  "loadingBackground": "LoadingBackground-module__O8pZKG__loadingBackground",
  "loadingBackgroundWrapper": "LoadingBackground-module__O8pZKG__loadingBackgroundWrapper",
  "placeHolderShimmer": "LoadingBackground-module__O8pZKG__placeHolderShimmer",
});
